<div class="w-full create-activity-one cst-content-ctnr">
  <div
    class="w-full p-8 bg-zinc-100 dark:bg-gray-800 flex-col justify-start items-start gap-2.5 inline-flex"
  >
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div
      class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
    >
      <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
        <div
          class="w-full grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
        >
          <div
            class="text-4xl w-full titre self-stretch text-gray-900 text-4xl font-semibold leading-[38px]"
          >
            {{
              modeModification ? "Modifier l'activité" : "Créer une activité"
            }}
          </div>
          <!-- ===== AJOUT : chargement de l'activité à modifier ===== -->
          <p class="fd-hint mt-1" *ngIf="chargementActivite">
            Chargement de l'activité…
          </p>

          <!-- ===== DÉBUT AJOUT : notification pleine largeur ===== -->
          <div
            *ngIf="toast"
            class="fd-banner"
            [class.is-succes]="toast.type === 'succes'"
            [class.is-erreur]="toast.type === 'erreur'"
            [attr.role]="toast.type === 'erreur' ? 'alert' : 'status'"
            aria-live="polite"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <ng-container *ngIf="toast.type === 'succes'; else iconeErreur">
                <circle cx="12" cy="12" r="9" />
                <path d="M8 12l3 3 5-6" />
              </ng-container>
              <ng-template #iconeErreur>
                <circle cx="12" cy="12" r="9" />
                <path d="M12 8v5M12 16.5v.5" />
              </ng-template>
            </svg>
            <span class="fd-banner-msg">
              <strong>{{ toast.titre }}</strong> {{ toast.message }}
            </span>
            <button
              type="button"
              class="fd-banner-close"
              (click)="fermerToast()"
              aria-label="Fermer"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </div>
          <!-- ===== FIN AJOUT : notification pleine largeur ===== -->

          <!-- ===== DÉBUT REFONTE : formulaire ===== -->
          <form class="w-full mt-6" [formGroup]="activityForm">
            <div class="w-full">
              <!-- ========== COLONNE GAUCHE : les sections ========== -->
              <div class="flex flex-col gap-5">
                <!-- ===== SECTION 1 : Informations générales ===== -->
                <section class="fd-section">
                  <div class="fd-section-title">
                    <span class="fd-step">1</span> Informations générales
                  </div>

                  <!-- Nom -->
                  <div class="fd-field">
                    <label
                      class="fd-label font-medium inter-medium f14 color-gray-700"
                      for="nomactivite"
                      >Nom de l'activité</label
                    >
                    <input
                      id="nomactivite"
                      type="text"
                      formControlName="activityName"
                      class="fd-input mat-mdc-input-element"
                      [class.is-invalid]="isFieldInvalid('activityName')"
                      placeholder="Ex. Bootcamp Data – Ziguinchor"
                    />
                    <p class="fd-error" *ngIf="isFieldInvalid('activityName')">
                      Le nom de l'activité est obligatoire.
                    </p>
                  </div>

                  <!-- ===== DÉBUT MODIF : le pays avant le type ===== -->
                  <!-- Pays -->
                  <div class="fd-field">
                    <span
                      class="fd-label font-medium inter-medium f14 color-gray-700"
                      >Pays de l'activité</span
                    >
                    <div
                      class="fd-segmented"
                      role="group"
                      aria-label="Pays de l'activité"
                    >
                      <button
                        *ngFor="let pays of paysAffiches"
                        type="button"
                        [disabled]="modeModification"
                        [attr.aria-pressed]="
                          activityForm.get('countryFlag')?.value === pays.flag
                        "
                        [class.is-active]="
                          activityForm.get('countryFlag')?.value === pays.flag
                        "
                        (click)="choisirPays(pays.flag)"
                      >
                        {{ pays.label }}
                      </button>
                    </div>
                  </div>

                  <!-- Type -->
                  <div class="fd-field">
                    <span
                      class="fd-label font-medium inter-medium f14 color-gray-700"
                      >Type d'activité</span
                    >
                    <div
                      class="fd-choice-grid"
                      role="group"
                      aria-label="Type d'activité"
                    >
                      <button
                        *ngFor="let t of typesAffiches"
                        type="button"
                        class="fd-choice"
                        [disabled]="modeModification"
                        [attr.aria-pressed]="
                          activityForm.get('activityType')?.value === t.value
                        "
                        [class.is-active]="
                          activityForm.get('activityType')?.value === t.value
                        "
                        (click)="choisirType(t.value)"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            icone;
                            context: { $implicit: iconeType(t.value) }
                          "
                        ></ng-container>
                        <span>{{ t.name }}</span>
                      </button>
                    </div>
                    <p
                      class="fd-hint mt-2"
                      *ngIf="
                        !modeModification &&
                        activityForm.get('countryFlag')?.value === 'bj'
                      "
                    >
                      Au Bénin, seules les activités informelles sont proposées.
                    </p>
                    <!-- ===== AJOUT : pays et type verrouillés en modification ===== -->
                    <p
                      class="fd-hint fd-hint-verrou mt-2"
                      *ngIf="modeModification"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          icone;
                          context: { $implicit: 'lock', petit: true }
                        "
                      ></ng-container>
                      Le pays et le type ne peuvent pas être modifiés.
                    </p>
                    <p class="fd-error" *ngIf="isFieldInvalid('activityType')">
                      Choisis un type d'activité.
                    </p>
                  </div>
                  <!-- ===== FIN MODIF : le pays avant le type ===== -->

                  <!-- Description -->
                  <div class="fd-field">
                    <label
                      class="fd-label font-medium inter-medium f14 color-gray-700"
                      for="description"
                    >
                      <span>Description, modalités de participation</span>
                      <span class="fd-label-hint"
                        >{{ nbCaracteresDescription }}/300</span
                      >
                    </label>
                    <textarea
                      id="description"
                      formControlName="description"
                      maxlength="300"
                      class="fd-input mat-mdc-input-element fd-textarea"
                      [class.is-invalid]="isFieldInvalid('description')"
                      placeholder="Objectifs, public visé, modalités de participation…"
                    ></textarea>
                    <p class="fd-error" *ngIf="isFieldInvalid('description')">
                      La description est obligatoire.
                    </p>
                  </div>
                </section>
                <!-- ===== FIN SECTION 1 ===== -->

                <!-- ===== DÉBUT AJOUT : public et participants verrouillés en modification ===== -->
                <section class="fd-section" *ngIf="publicVerrouille">
                  <div class="fd-section-title">
                    <span class="fd-step">2</span> Public et participants
                  </div>
                  <div class="fd-verrou">
                    <ng-container
                      *ngTemplateOutlet="
                        icone;
                        context: { $implicit: 'lock', petit: true }
                      "
                    ></ng-container>
                    <span>
                      <strong>Non modifiables pour l'instant.</strong> Pour voir
                      la liste, utilise le bouton « Participants » de l'agenda.
                    </span>
                  </div>
                </section>
                <!-- ===== FIN AJOUT ===== -->

                <!-- ===== SECTION 2 : Public concerné (Événement, Webinaire, Bootcamp) ===== -->
                <section class="fd-section" *ngIf="afficherPublic">
                  <div class="fd-section-title">
                    <span class="fd-step">2</span> Public concerné
                  </div>

                  <div
                    class="fd-option-grid"
                    role="group"
                    aria-label="Public concerné"
                  >
                    <button
                      *ngFor="let o of optionsAudience"
                      type="button"
                      class="fd-option"
                      [attr.aria-pressed]="estAudience(o.valeur)"
                      [class.is-active]="estAudience(o.valeur)"
                      (click)="choisirAudience(o.valeur)"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          icone;
                          context: { $implicit: o.icone }
                        "
                      ></ng-container>
                      <span>
                        <span class="fd-option-title">{{ o.titre }}</span>
                        <span class="fd-option-detail">{{ o.detail }}</span>
                      </span>
                    </button>
                  </div>
                  <p class="fd-error" *ngIf="isFieldInvalid('activitStatus')">
                    Choisis le public concerné.
                  </p>

                  <!-- Par certificat : cohorte + certificats -->
                  <div
                    class="fd-subpanel"
                    *ngIf="estAudience(activityStatus.BY_CERTIFICATE_TYPE)"
                  >
                    <div>
                      <span
                        class="fd-label font-medium inter-medium f14 color-gray-700"
                        >Cohorte</span
                      >
                      <mat-select
                        class="fd-select"
                        [class.is-invalid]="isFieldInvalid('cohort')"
                        formControlName="cohort"
                        placeholder="Choisir la cohorte"
                      >
                        <mat-option
                          *ngFor="let cohort of cohorts"
                          [value]="cohort"
                        >
                          {{ cohort }}
                        </mat-option>
                      </mat-select>
                      <p class="fd-error" *ngIf="isFieldInvalid('cohort')">
                        Choisis une cohorte.
                      </p>
                    </div>

                    <div>
                      <span
                        class="fd-label font-medium inter-medium f14 color-gray-700"
                        >Certificats concernés</span
                      >
                      <mat-select
                        class="fd-select"
                        [class.is-invalid]="isFieldInvalid('certificatIdList')"
                        formControlName="certificatIdList"
                        multiple
                        [placeholder]="
                          activityForm.get('cohort')?.value
                            ? 'Choisir les certificats'
                            : 'Choisis d\'abord une cohorte'
                        "
                      >
                        <mat-option
                          *ngFor="let certificat of recupNewParcoursCertif"
                          [value]="certificat.id"
                        >
                          {{ certificat.fullname | titlecase }}
                        </mat-option>
                      </mat-select>
                      <p
                        class="fd-error"
                        *ngIf="isFieldInvalid('certificatIdList')"
                      >
                        Choisis au moins un certificat.
                      </p>
                    </div>
                  </div>

                  <!-- Par zone de résidence : cohortes + zones + lien bootcamp -->
                  <div
                    class="fd-subpanel"
                    *ngIf="estAudience(activityStatus.BY_RESIDENCE_ZONE)"
                  >
                    <div>
                      <span
                        class="fd-label font-medium inter-medium f14 color-gray-700"
                        >Cohortes</span
                      >
                      <mat-select
                        class="fd-select"
                        [class.is-invalid]="isFieldInvalid('cohorts')"
                        formControlName="cohorts"
                        multiple
                        placeholder="Choisir les cohortes"
                      >
                        <mat-option
                          *ngFor="let cohort of cohorts"
                          [value]="cohort"
                        >
                          {{ cohort }}
                        </mat-option>
                      </mat-select>
                      <p class="fd-error" *ngIf="isFieldInvalid('cohorts')">
                        Choisis au moins une cohorte.
                      </p>
                    </div>

                    <div>
                      <span
                        class="fd-label font-medium inter-medium f14 color-gray-700"
                        >Zones de résidence</span
                      >
                      <mat-select
                        class="fd-select"
                        [class.is-invalid]="isFieldInvalid('localities')"
                        formControlName="localities"
                        multiple
                        placeholder="Choisir les zones"
                      >
                        <mat-option
                          *ngFor="let locality of localities"
                          [value]="locality"
                        >
                          {{ locality }}
                        </mat-option>
                      </mat-select>
                      <p class="fd-error" *ngIf="isFieldInvalid('localities')">
                        Choisis au moins une zone.
                      </p>
                    </div>

                    <div class="fd-full">
                      <label
                        class="fd-label font-medium inter-medium f14 color-gray-700"
                        for="bootcampLink"
                        >Lien email d'accès bootcamp</label
                      >
                      <input
                        id="bootcampLink"
                        type="url"
                        formControlName="bootcampLink"
                        class="fd-input mat-mdc-input-element"
                        [class.is-invalid]="isFieldInvalid('bootcampLink')"
                        placeholder="https://…"
                      />
                      <p
                        class="fd-error"
                        *ngIf="isFieldInvalid('bootcampLink')"
                      >
                        Le lien est obligatoire pour ce public.
                      </p>
                    </div>
                  </div>

                  <!-- À définir -->
                  <p
                    class="fd-hint mt-3"
                    *ngIf="estAudience(activityStatus.TO_DEFINE)"
                  >
                    Aucun participant ne sera ajouté pour l'instant. Tu pourras
                    préciser le public plus tard.
                  </p>
                </section>
                <!-- ===== FIN SECTION 2 : Public concerné ===== -->

                <!-- ===== SECTION 2 : Participants (Atelier Force-N) ===== -->
                <!-- ===== MODIF : masquée en modification ===== -->
                <section
                  class="fd-section"
                  *ngIf="isAtelierForceNSelected() && !modeModification"
                >
                  <div class="fd-section-title">
                    <span class="fd-step">2</span> Participants
                  </div>

                  <div *ngIf="listPersonnel.length; else aucunPersonnel">
                    <p class="fd-hint mb-2">
                      {{ listPersonnel.length }} personne(s) sélectionnée(s)
                    </p>
                    <div class="fd-chips mb-3">
                      <span class="fd-chip" *ngFor="let p of personnelChoisi">
                        {{ p.prenom }} {{ p.nom }}
                        <button
                          type="button"
                          (click)="retirerPersonnel(p.iuf)"
                          aria-label="Retirer"
                        >
                          <ng-container
                            *ngTemplateOutlet="
                              icone;
                              context: { $implicit: 'close', petit: true }
                            "
                          ></ng-container>
                        </button>
                      </span>
                    </div>
                  </div>
                  <ng-template #aucunPersonnel>
                    <p class="fd-hint mb-3">
                      Aucun membre du personnel sélectionné pour l'instant.
                    </p>
                  </ng-template>

                  <button
                    type="button"
                    class="fd-btn-outline"
                    (click)="ouvrirSelectionPersonnel()"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        icone;
                        context: { $implicit: 'person_add', petit: true }
                      "
                    ></ng-container>
                    {{
                      listPersonnel.length
                        ? "Modifier la sélection"
                        : "Sélectionner le personnel"
                    }}
                  </button>
                </section>
                <!-- ===== FIN SECTION 2 : Participants ===== -->

                <!-- ===== SECTION : Dates et horaire ===== -->
                <section class="fd-section">
                  <div class="fd-section-title">
                    <span class="fd-step">{{ num.dates }}</span> Dates et
                    horaire
                  </div>

                  <!-- ===== DÉBUT AJOUT : période déduite des sessions (activité informelle) ===== -->
                  <div
                    class="fd-summary"
                    *ngIf="isCommercantLivreurSelected(); else champsDates"
                  >
                    <ng-container
                      *ngIf="periodeSessions as p; else aucunePeriode"
                    >
                      <strong *ngIf="p.debut === p.fin">
                        Le {{ p.debut | date: "EEEE dd MMMM yyyy" : "" : "fr" }}
                      </strong>
                      <strong *ngIf="p.debut !== p.fin">
                        Du {{ p.debut | date: "EEEE dd MMMM" : "" : "fr" }} au
                        {{ p.fin | date: "EEEE dd MMMM yyyy" : "" : "fr" }}
                      </strong>
                      · premier créneau à {{ p.heure }}
                    </ng-container>
                    <ng-template #aucunePeriode>
                      La période apparaîtra ici dès que tu auras saisi une
                      session.
                    </ng-template>
                    <p class="fd-hint">
                      Calculée automatiquement à partir des lieux et sessions.
                    </p>
                  </div>
                  <ng-template #champsDates>
                    <!-- ===== FIN AJOUT ===== -->

                    <div class="fd-grid-3">
                      <div>
                        <label
                          class="fd-label font-medium inter-medium f14 color-gray-700"
                          for="datedebut"
                          >Date de début</label
                        >
                        <input
                          id="datedebut"
                          type="date"
                          formControlName="beginDate"
                          class="fd-input mat-mdc-input-element"
                          [class.is-invalid]="isFieldInvalid('beginDate')"
                        />
                        <p class="fd-error" *ngIf="isFieldInvalid('beginDate')">
                          La date de début est obligatoire.
                        </p>
                      </div>

                      <div>
                        <label
                          class="fd-label font-medium inter-medium f14 color-gray-700"
                          for="datefin"
                          >Date de fin</label
                        >
                        <input
                          id="datefin"
                          type="date"
                          formControlName="closeDate"
                          class="fd-input mat-mdc-input-element"
                          [class.is-invalid]="
                            isFieldInvalid('closeDate') ||
                            (activityForm.hasError('datesInversees') &&
                              activityForm.get('closeDate')?.touched)
                          "
                          [min]="activityForm.get('beginDate')?.value"
                        />
                        <p class="fd-error" *ngIf="isFieldInvalid('closeDate')">
                          La date de fin est obligatoire.
                        </p>
                        <!-- ===== AJOUT : dates inversées ===== -->
                        <p
                          class="fd-error"
                          *ngIf="
                            activityForm.hasError('datesInversees') &&
                            activityForm.get('closeDate')?.touched
                          "
                        >
                          La date de fin doit être après la date de début.
                        </p>
                      </div>

                      <div>
                        <label
                          class="fd-label font-medium inter-medium f14 color-gray-700"
                          for="heure"
                          >Heure</label
                        >
                        <input
                          id="heure"
                          type="time"
                          formControlName="heure"
                          class="fd-input mat-mdc-input-element heure-input"
                          [class.is-invalid]="isFieldInvalid('heure')"
                        />
                        <p class="fd-error" *ngIf="isFieldInvalid('heure')">
                          L'heure est obligatoire.
                        </p>
                      </div>
                    </div>
                    <!-- ===== DÉBUT AJOUT ===== -->
                  </ng-template>
                  <!-- ===== FIN AJOUT ===== -->

                  <!-- Type de test : affiché seulement si testActive (inchangé) -->
                  <div class="fd-field" *ngIf="testActive">
                    <label
                      class="fd-label font-medium inter-medium f14 color-gray-700"
                      for="typetest"
                      >Type de test</label
                    >
                    <select
                      id="typetest"
                      formControlName="typeTest"
                      class="fd-input mat-mdc-input-element"
                    >
                      <option value="" disabled selected>
                        Choisir le type de test
                      </option>
                      <option *ngFor="let r of testType" [ngValue]="r.value">
                        {{ r.name }}
                      </option>
                    </select>
                  </div>
                </section>
                <!-- ===== FIN SECTION : Dates et horaire ===== -->

                <!-- ===== SECTION : Accès et lieu ===== -->
                <section class="fd-section">
                  <div class="fd-section-title">
                    <span class="fd-step">{{ num.acces }}</span> Accès et lieu
                  </div>

                  <div class="fd-grid-2">
                    <div>
                      <label
                        class="fd-label font-medium inter-medium f14 color-gray-700"
                        for="lienaccess"
                        >Lien d'accès</label
                      >
                      <input
                        id="lienaccess"
                        type="url"
                        formControlName="link"
                        class="fd-input mat-mdc-input-element"
                        [class.is-invalid]="isFieldInvalid('link')"
                        placeholder="https://…"
                      />
                      <p class="fd-error" *ngIf="isFieldInvalid('link')">
                        Le lien d'accès est obligatoire.
                      </p>
                    </div>

                    <div>
                      <label
                        class="fd-label font-medium inter-medium f14 color-gray-700"
                        for="adresse"
                        >Adresse</label
                      >
                      <input
                        id="adresse"
                        type="text"
                        formControlName="adress"
                        class="fd-input mat-mdc-input-element"
                        [class.is-invalid]="isFieldInvalid('adress')"
                        placeholder="Lieu, quartier, ville"
                      />
                      <p class="fd-error" *ngIf="isFieldInvalid('adress')">
                        L'adresse est obligatoire.
                      </p>
                    </div>
                  </div>
                </section>
                <!-- ===== FIN SECTION : Accès et lieu ===== -->

                <!-- ===== SECTION : Lieux et sessions (COMMERCANT_LIVREUR) ===== -->
                <section
                  class="fd-section"
                  *ngIf="isCommercantLivreurSelected()"
                >
                  <div class="fd-section-title">
                    <span class="fd-step">{{ num.sessions }}</span> Lieux et
                    sessions
                  </div>

                  <app-activity-sessions-editor
                    [lieuxArray]="lieuxArray"
                    [villes]="villesPays"
                  ></app-activity-sessions-editor>
                </section>
                <!-- ===== FIN SECTION : Lieux et sessions ===== -->
                <!-- ===== DÉBUT MODIF : barre d'actions ===== -->
                <div class="fd-actions">
                  <span
                    class="fd-actions-msg"
                    *ngIf="tentativeEnvoi && activityForm.invalid"
                  >
                    {{ nbChampsInvalides }} champ(s) à compléter
                  </span>
                  <button
                    type="button"
                    class="fd-btn-secondary"
                    (click)="goToAgenda()"
                  >
                    Annuler
                  </button>
                  <!-- ===== MODIF : libellé selon le mode (création / modification) ===== -->
                  <button
                    type="button"
                    class="fd-btn-primary"
                    (click)="openConfirmModal()"
                    [disabled]="isSubmitting || chargementActivite"
                  >
                    {{
                      isSubmitting
                        ? "Enregistrement…"
                        : modeModification
                          ? "Enregistrer les modifications"
                          : "Sauvegarder"
                    }}
                  </button>
                  <!-- ===== FIN MODIF ===== -->
                </div>
                <!-- ===== FIN MODIF : barre d'actions ===== -->
              </div>
            </div>
          </form>
          <!-- ===== FIN REFONTE : formulaire ===== -->
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de confirmation -->
  <div
    *ngIf="showConfirmModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6"
    >
      <!-- Icône + Titre -->
      <div class="flex flex-col items-center gap-3 text-center">
        <div class="bg-blue-100 rounded-full p-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-10 w-10 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <!-- ===== MODIF : textes selon le mode ===== -->
        <h2 class="text-2xl font-semibold text-gray-900">
          {{
            modeModification
              ? "Confirmer les modifications"
              : "Confirmer la création"
          }}
        </h2>
        <p class="text-slate-600 text-base">
          {{
            modeModification
              ? "Vous êtes sur le point de modifier cette activité."
              : "Vous êtes sur le point de créer une activité."
          }}<br />
          Voulez-vous confirmer cette action ?
        </p>
      </div>

      <!-- ===== DÉBUT MODIF : récapitulatif avec libellés ===== -->
      <div
        class="bg-zinc-50 rounded-lg border border-gray-200 px-5 py-4 text-sm text-gray-700 flex flex-col gap-2"
      >
        <div class="flex justify-between gap-4">
          <span class="font-medium text-gray-500">Nom :</span>
          <span class="font-semibold text-right">{{
            activityForm.get("activityName")?.value
          }}</span>
        </div>
        <div class="flex justify-between gap-4">
          <span class="font-medium text-gray-500">Type :</span>
          <span class="text-right">{{ libelleType }}</span>
        </div>
        <div class="flex justify-between gap-4">
          <span class="font-medium text-gray-500">Pays :</span>
          <span class="text-right">{{ nomPaysChoisi }}</span>
        </div>

        <!-- Public (Webinaire, Bootcamp…) -->
        <div
          class="flex justify-between gap-4"
          *ngIf="afficherPublic && libelleAudience"
        >
          <span class="font-medium text-gray-500">Public :</span>
          <span class="text-right">{{ libelleAudience }}</span>
        </div>
        <div
          class="flex justify-between gap-4"
          *ngIf="
            afficherPublic && estAudience(activityStatus.BY_CERTIFICATE_TYPE)
          "
        >
          <span class="font-medium text-gray-500">Cohorte :</span>
          <span class="text-right">{{
            activityForm.get("cohort")?.value
          }}</span>
        </div>
        <div
          class="flex justify-between gap-4"
          *ngIf="
            afficherPublic && estAudience(activityStatus.BY_CERTIFICATE_TYPE)
          "
        >
          <span class="font-medium text-gray-500">Certificats :</span>
          <span class="text-right"
            >{{
              activityForm.get("certificatIdList")?.value?.length || 0
            }}
            sélectionné(s)</span
          >
        </div>
        <div
          class="flex justify-between gap-4"
          *ngIf="
            afficherPublic && estAudience(activityStatus.BY_RESIDENCE_ZONE)
          "
        >
          <span class="font-medium text-gray-500">Cohortes :</span>
          <span class="text-right">{{
            activityForm.get("cohorts")?.value?.join(", ")
          }}</span>
        </div>
        <div
          class="flex justify-between gap-4"
          *ngIf="
            afficherPublic && estAudience(activityStatus.BY_RESIDENCE_ZONE)
          "
        >
          <span class="font-medium text-gray-500">Zones :</span>
          <span class="text-right">{{
            activityForm.get("localities")?.value?.join(", ")
          }}</span>
        </div>

        <!-- Participants (Atelier Force-N) -->
        <div
          class="flex justify-between gap-4"
          *ngIf="isAtelierForceNSelected() && !modeModification"
        >
          <span class="font-medium text-gray-500">Personnel :</span>
          <span class="text-right">{{ listPersonnel.length }} personne(s)</span>
        </div>

        <!-- Dates et horaire -->
        <div class="flex justify-between gap-4">
          <span class="font-medium text-gray-500">Période :</span>
          <span class="text-right">
            {{
              activityForm.get("beginDate")?.value
                | date: "dd MMMM yyyy" : "" : "fr"
            }}
            <ng-container
              *ngIf="
                activityForm.get('closeDate')?.value &&
                activityForm.get('closeDate')?.value !==
                  activityForm.get('beginDate')?.value
              "
            >
              →
              {{
                activityForm.get("closeDate")?.value
                  | date: "dd MMMM yyyy" : "" : "fr"
              }}
            </ng-container>
          </span>
        </div>
        <div class="flex justify-between gap-4">
          <span class="font-medium text-gray-500">Heure :</span>
          <span class="text-right">{{ activityForm.get("heure")?.value }}</span>
        </div>

        <!-- Sessions (Activité informelle) -->
        <div
          class="flex justify-between gap-4"
          *ngIf="isCommercantLivreurSelected()"
        >
          <span class="font-medium text-gray-500">Sessions :</span>
          <span class="text-right">{{ resumeSessions }}</span>
        </div>
      </div>
      <!-- ===== FIN MODIF : récapitulatif avec libellés ===== -->

      <!-- Boutons -->
      <div class="flex justify-end gap-3">
        <button
          (click)="cancelSubmit()"
          class="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 transition focus:outline-none"
        >
          Annuler
        </button>
        <button
          (click)="confirmSubmit()"
          class="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold transition focus:outline-none"
        >
          Confirmer
        </button>
      </div>
    </div>
  </div>

  <!-- ===== DÉBUT AJOUT : fenêtre « quitter sans enregistrer » ===== -->
  <div
    *ngIf="showQuitterModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
    (click)="resterSurLeFormulaire()"
  >
    <div
      class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="quitter-titre"
      aria-describedby="quitter-texte"
      (click)="$event.stopPropagation()"
    >
      <!-- Icône + titre -->
      <div class="flex flex-col items-center gap-3 text-center">
        <div class="bg-amber-100 rounded-full p-4">
          <svg
            class="h-10 w-10 text-amber-600"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M12 9v4M12 17h.01" />
            <path
              d="M10.3 3.9L2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"
            />
          </svg>
        </div>
        <h2 id="quitter-titre" class="text-2xl font-semibold text-gray-900">
          Quitter sans enregistrer ?
        </h2>
        <p id="quitter-texte" class="text-slate-600 text-base">
          <!-- ===== MODIF : textes selon le mode ===== -->
          {{
            modeModification
              ? "Tes modifications seront perdues."
              : "Les informations que tu as saisies seront perdues."
          }}<br />
          {{
            modeModification
              ? "L'activité restera telle qu'elle était."
              : "L'activité ne sera pas créée."
          }}
        </p>
      </div>

      <!-- Boutons -->
      <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
        <button
          type="button"
          class="px-5 py-2.5 rounded-lg border border-red-300 text-red-700 font-medium hover:bg-red-50 transition"
          (click)="quitterSansEnregistrer()"
        >
          Quitter sans enregistrer
        </button>
        <button
          type="button"
          class="px-5 py-2.5 rounded-lg text-white font-semibold transition"
          style="background: var(--fd-primary)"
          (click)="resterSurLeFormulaire()"
          cdkFocusInitial
          autofocus
        >
          Continuer la saisie
        </button>
      </div>
    </div>
  </div>
  <!-- ===== FIN AJOUT ===== -->
</div>
<div *ngIf="showPersonnel">
  <app-personnel-forcen
    [selectionInitiale]="personnelChoisi"
    (emitPersonnel)="emettreLaliste($event)"
  ></app-personnel-forcen>
</div>

<!-- ===== DÉBUT AJOUT : icônes du formulaire (style barre latérale) ===== -->
<ng-template #icone let-nom let-petit="petit">
  <svg
    [attr.width]="petit ? 16 : 24"
    [attr.height]="petit ? 16 : 24"
    [style.width.px]="petit ? 16 : 24"
    [style.height.px]="petit ? 16 : 24"
    style="flex-shrink: 0"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    [ngSwitch]="nom"
  >
    <!-- Événement : calendrier -->
    <g *ngSwitchCase="'event'">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </g>
    <!-- Webinaire : caméra (même tracé que le menu) -->
    <g *ngSwitchCase="'videocam'">
      <path
        d="M15 10L19 7V17L15 14V17C15 18.1046 14.1046 19 13 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H13C14.1046 5 15 5.89543 15 7V10Z"
      />
      <circle cx="9" cy="11" r="2" />
    </g>
    <!-- Bootcamp : drapeau -->
    <g *ngSwitchCase="'flag'">
      <path d="M5 21V4M5 4h11l-2 4 2 4H5" />
    </g>
    <!-- Mini JPO : petite porte ouverte -->
    <g *ngSwitchCase="'groups'">
      <path d="M6 20h12M8 20V9h6v11M14 9l3 1.5V20" />
      <circle cx="12" cy="15" r="0.7" fill="currentColor" />
    </g>
    <!-- JPO : porte ouverte -->
    <g *ngSwitchCase="'apartment'">
      <path d="M4 21h16M6 21V4h9v17M15 4l4 2v15" />
      <circle cx="12.5" cy="13" r="0.8" fill="currentColor" />
    </g>
    <!-- Atelier Force-N : clé -->
    <g *ngSwitchCase="'build'">
      <path
        d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-.6-.6-2.4z"
      />
    </g>
    <!-- Masterclass : tableau de présentation -->
    <g *ngSwitchCase="'school'">
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M12 16v4M8 20h8M7 9l3 2 3-3 4 3" />
    </g>
    <!-- Activité informelle : étal de marché -->
    <g *ngSwitchCase="'local_shipping'">
      <path d="M3 9l1.5-5h15L21 9" />
      <path
        d="M3 9c0 1.4 1 2.5 2.25 2.5S7.5 10.4 7.5 9c0 1.4 1 2.5 2.25 2.5S12 10.4 12 9c0 1.4 1 2.5 2.25 2.5S16.5 10.4 16.5 9c0 1.4 1 2.5 2.25 2.5S21 10.4 21 9"
      />
      <path d="M5 11.5V20h14v-8.5M10 20v-4h4v4" />
    </g>
    <!-- Audience : tous les apprenants -->
    <g *ngSwitchCase="'public'">
      <circle cx="12" cy="12" r="9" />
      <path
        d="M3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z"
      />
    </g>
    <!-- Audience : par certificat -->
    <g *ngSwitchCase="'star'">
      <circle cx="12" cy="9" r="5" />
      <path d="M8.5 13.5L7 21l5-3 5 3-1.5-7.5" />
    </g>
    <!-- Audience : par zone de résidence -->
    <g *ngSwitchCase="'location_on'">
      <path d="M12 21s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12z" />
      <circle cx="12" cy="9" r="2.5" />
    </g>
    <!-- Audience « À définir » : point d'interrogation -->
    <g *ngSwitchCase="'schedule'">
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5v.7" />
      <circle cx="12" cy="17" r="0.8" fill="currentColor" />
    </g>
    <!-- Retirer -->
    <g *ngSwitchCase="'close'">
      <path d="M6 6l12 12M18 6L6 18" />
    </g>
    <!-- Ajouter du personnel -->
    <g *ngSwitchCase="'person_add'">
      <circle cx="10" cy="8" r="3.5" />
      <path d="M3 20c0-3.6 3.1-6.5 7-6.5M18 14v6M15 17h6" />
    </g>
    <!-- ===== AJOUT : cadenas (mode modification) ===== -->
    <g *ngSwitchCase="'lock'">
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </g>
    <!-- Par défaut : calendrier -->
    <g *ngSwitchDefault>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </g>
  </svg>
</ng-template>
<!-- ===== FIN AJOUT : icônes du formulaire ===== -->
